import { useState } from "react";
import { CrudModule } from "@/command/ccCrud";

export default function Operations() {
  const [tab, setTab] = useState("projects");
  return (
    <div>
      <h1 className="display text-2xl md:text-3xl font-light text-ink">Operations</h1>
      <p className="text-subtle mt-1 mb-6">Projects and tasks with owners, progress and due dates — live.</p>

      <div className="flex flex-wrap gap-2 mb-5">
        {[["projects", "Projects"], ["tasks", "Tasks"]].map(([k, v]) => (
          <button key={k} onClick={() => setTab(k)} data-testid={`ops-tab-${k}`}
            className={`px-4 py-2 rounded-full text-sm transition-colors ${tab === k ? "bg-invert text-invert-ink" : "glass-medium text-subtle hover:text-ink"}`}>{v}</button>
        ))}
      </div>

      {tab === "projects" ? (
        <CrudModule
          module="operations" endpoint="/cc/operations/projects" entity="project" summaryPath="/cc/operations/summary"
          columns={[["name", "Project"], ["owner", "Owner"], ["status", "Status", "badge"], ["progress", "Progress", "progress"], ["due_date", "Due"]]}
          fields={[["name", "Project", "text"], ["owner", "Owner", "text"], ["status", "Status", "select", ["Planned", "Active", "On Hold", "Completed"]],
            ["progress", "Progress %", "number"], ["due_date", "Due date", "date"]]}
          defaults={{ status: "Planned", progress: 0 }}
          kpis={(rows, s) => [
            { label: "Projects", value: s?.projects ?? rows.length },
            { label: "Active", value: s?.projects_active ?? 0 },
            { label: "Open Tasks", value: s?.tasks_open ?? 0 },
            { label: "Overdue Tasks", value: s?.tasks_overdue ?? 0 },
          ]}
        />
      ) : (
        <CrudModule
          module="operations" endpoint="/cc/operations/tasks" entity="task" hideKpis
          columns={[["title", "Task"], ["project", "Project"], ["owner", "Owner"], ["priority", "Priority", "badge"], ["status", "Status", "badge"], ["due_date", "Due"]]}
          fields={[["title", "Task", "text"], ["project", "Project", "text"], ["owner", "Owner", "text"],
            ["priority", "Priority", "select", ["Low", "Medium", "High"]], ["status", "Status", "select", ["To Do", "In Progress", "Done"]], ["due_date", "Due date", "date"]]}
          defaults={{ status: "To Do", priority: "Medium" }}
        />
      )}
    </div>
  );
}
